const routerArr = [
  {
    path: '/grouppurchase/poster', // 海报页1
    name: 'poster',
    meta: { title:'818嗨课节',login:false },
    component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/poster.vue'),
  },{
    path: '/grouppurchase/swipePoster', // 海报2
    name: 'swipePoster',
    meta: { title:'818嗨课节',login:false },
    component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/swipePoster.vue'),
  },
  {
    path: '/grouppurchase/activity', // 818活动页
    name: 'activity',
    meta: { title:'818嗨课节',login:false },
    component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/activity.vue'),
  },
  {
    path: '/grouppurchasedetail',
    name: 'grouppurchasedetail',
    meta: { title:'拼单详情',login:false },
    component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/grouppurchasedetail.vue'),
  },
  {
    path: '/grouppurchasedetailInvite',
    name: 'grouppurchasedetailInvite',
    meta: { title:'拼单详情',login:false },
    component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/grouppurchasedetail-invite.vue'),
  },
  // {
  //   path: '/customerService',
  //   name: 'customerService',
  //   meta: { title:'添加客服',login:false },
  //   component: () => import(/* webpackChunkName: 'grouppurchase' */ './page/customerService.vue'),
  // }
]
export default routerArr